export const PRODUCT_TYPE_STORE = 'PRODUCT_TYPE_STORE';
export const PRODUCT_TYPE_UPDATE = 'PRODUCT_TYPE_UPDATE';
export const PRODUCT_TYPE_DESTROY = 'PRODUCT_TYPE_DESTROY';
